import { render, staticRenderFns } from "./PbContributorTerms.vue?vue&type=template&id=48d9b4aa"
import script from "./PbContributorTerms.vue?vue&type=script&lang=js"
export * from "./PbContributorTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports